import React from 'react';

const VirtualKeyboard = ({ onKeyPress, onBackspace, onClear, position, isVisible }) => {
  if (!isVisible) return null;

  const keys = [
    '1', '2', '3', '4',
    '5', '6', '7', '8', 
    '9', '0', '⌫', 'C'
  ];

  const handleKeyClick = (key, event) => {
    console.log('Virtual keyboard button clicked:', key);
    
    // Prevent the button click from stealing focus from the input field
    event.preventDefault();
    event.stopPropagation();
    
    if (key === '⌫') {
      console.log('Calling onBackspace');
      onBackspace();
    } else if (key === 'C') {
      console.log('Calling onClear');
      onClear();
    } else {
      console.log('Calling onKeyPress with:', key);
      onKeyPress(key);
    }
  };

  return (
    <div 
      className="virtual-keyboard"
      style={{
        position: 'absolute',
        left: position.x,
        top: position.y,
        backgroundColor: 'white',
        border: '2px solid #3498db',
        borderRadius: '8px',
        padding: '12px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        zIndex: 1000,
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gridTemplateRows: 'repeat(3, 1fr)',
        gap: '6px',
        width: '240px',
        height: '180px'
      }}
    >
      {keys.map((key) => (
        <button
          key={key}
          onClick={(event) => handleKeyClick(key, event)}
          tabIndex={-1}
          style={{
            width: '100%',
            height: '100%',
            fontSize: '1.2rem',
            fontWeight: 'bold',
            border: '1px solid #ddd',
            borderRadius: '6px',
            backgroundColor: key === '⌫' ? '#e74c3c' : key === 'C' ? '#f39c12' : '#f8f9fa',
            color: key === '⌫' || key === 'C' ? 'white' : '#333',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '45px'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = key === '⌫' ? '#c0392b' : key === 'C' ? '#e67e22' : '#e9ecef';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = key === '⌫' ? '#e74c3c' : key === 'C' ? '#f39c12' : '#f8f9fa';
          }}
        >
          {key}
        </button>
      ))}
    </div>
  );
};

export default VirtualKeyboard; 